module.exports = __webpack_public_path__ + "97d4f64b213f3e5163827754c213bb4e.woff2";